// extracted by mini-css-extract-plugin
module.exports = {"GlobalFabButton":"GlobalFab_GlobalFabButton__1t8H_"};